<form [formGroup]="horizonsTeamForm" (ngSubmit)="save()">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'name-' + horizonsTeam.id" class="col-sm-5 col-form-label">{{ 'ENTITY.NAME' | translate }} *</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'name-' + horizonsTeam.id" formControlName="name">
          <hbo-control-messages [control]="horizonsTeamForm.get('name')!" [component]="'horizonsTeam-actions'" [errorMessage]="'error'"></hbo-control-messages>
        </div>
      </div>

      <small>* {{ 'COMMON.MANDATORY' | translate }}</small>
    </div>

    <div class="col-6">

    </div>
  </div>

  <div class="p-4" *ngIf="user.profileId === 3">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="submit" class="btn btn-dark">{{ 'COMMON.SAVE_CHANGES' | translate }}</button>
    <button type="button" class="btn btn-outline-secondary float-end" data-bs-toggle="modal" [attr.data-bs-target]="'#confirmationModal-' + horizonsTeam.id" *ngIf="action === 'edit'">
      <i class="bi bi-trash3"></i> {{ 'COMMON.DELETE' | translate }}
    </button>
  </div>
</form>

<hbo-confirmation-modal [id]="horizonsTeam.id" (confirm)="delete()"></hbo-confirmation-modal>
<hbo-confirmation-modal [id]="'horizonsTeam-delete'" (confirm)="utils.toogleModal('#confirmationModal-horizonsTeam-delete',true)" [hideConfirm]="true" [head]="'Horizons Team in use.'" [message]="'false'"></hbo-confirmation-modal>

